// extracted by mini-css-extract-plugin
export default {"newProject_container":"NovoMotivo_newProject_container__LwkPJ"};